module.exports = __webpack_public_path__ + "img/PolígonoT1.76d1d1a6.svg";